// TODO: Make this dynamic
import { FuturesMarketKey, FuturesMarketAsset } from '../types';
import { MarketAssetByKey, inverseObj } from '../utils';
export const V3_SYNTH_MARKET_IDS = {
    SNXUSD: 0,
    SNXBTC: 1,
    SNXETH: 2,
    SNXLINK: 3,
    SNXOP: 4,
};
export const V3_PERPS_MARKET_IDS = {
    [FuturesMarketKey.sETHPERP]: 100,
    [FuturesMarketKey.sBTCPERP]: 200,
    [FuturesMarketKey.sLINKPERP]: 300,
    [FuturesMarketKey.sOPPERP]: 400,
    [FuturesMarketKey.sSNXPERP]: 500,
};
export const V3_SYNTH_MARKET_KEYS = Object.keys(V3_SYNTH_MARKET_IDS);
export const V3_PERPS_MARKET_IDS_TO_KEYS = inverseObj(V3_PERPS_MARKET_IDS);
export const v3PerpsMarketIdToAssetKey = (marketId) => {
    const key = V3_PERPS_MARKET_IDS_TO_KEYS[marketId];
    return MarketAssetByKey[key];
};
export const v3SynthKeyToV2Asset = (key) => {
    const asset = key.replace('SNX', '');
    if (asset === 'ETH')
        return FuturesMarketAsset.sETH;
    if (asset === 'BTC')
        return FuturesMarketAsset.sBTC;
    if (asset === 'USD')
        return 'sUSD';
    return asset;
};
